import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'key', label: 'Key (unique)', type: 'text', placeholder: 'e.g. csr.eligibility, about.quality_policy' },
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'subtitle', label: 'Subtitle', type: 'text' },
    { key: 'body', label: 'Content', type: 'rich-text', minHeight: 300, hint: 'Rich text — headings, lists, links, and images all supported.' },
    { key: 'image_url', label: 'Header/side image', type: 'upload-image', prefix: 'content-blocks' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'key', label: 'Key', primary: true },
    { key: 'title', label: 'Title' },
];

const defaultItem = { key: '', title: '', subtitle: '', body: '', image_url: '', order: 99 };

export default function AdminContentBlocksPage() {
    return (
        <CrudManager
            resource="content-blocks"
            title="Content Blocks"
            description="Reusable rich-content blocks used across About, CSR Projects and more. WYSIWYG editing enabled."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['key', 'title']}
        />
    );
}
